// Internal notes — POST /api/conversations/:id/notes (visible to agents only, never to visitors).
import { addConversationNote } from "../api/services/conversationService";

export const addInternalNote = async (conversationId, note) => {
  if (!conversationId || !note?.trim()) throw new Error("Invalid note data");
  const created = await addConversationNote(conversationId, note.trim());
  return { success: true, data: { id: created.id, conversationId, text: created.text, createdAt: new Date(created.createdAt).toLocaleString() } };
};
